import { z } from "zod";
import { parseContainer, toContainer } from "./shared.js";
/** Loose envelope: validates only the top-level partitioning. Each container is validated
 *  independently via `parseContainer`, so one drifted container degrades to a load error
 *  without rejecting the other — mirrors `incidentOverviewEnvelopeSchema`'s contract. */
export const personOverviewEnvelopeSchema = z.object({
    claiminiId: z.string(),
    ContainerPersonType: z.unknown(),
    ContainerBankDetails: z.unknown(),
});
/**
 * Resilient counterpart to `personOverviewEnvelopeSchema.parse`: the envelope's shape must be
 * intact, but each container is parsed independently, so a single structurally-drifted container
 * degrades just that container to a load error instead of failing the whole response.
 */
export function parsePersonOverview(raw) {
    const envelope = personOverviewEnvelopeSchema.parse(raw);
    return {
        claiminiId: envelope.claiminiId,
        containers: {
            personType: toContainer(parseContainer(envelope.ContainerPersonType)),
            bankDetails: toContainer(parseContainer(envelope.ContainerBankDetails)),
        },
    };
}
